// tslint:disable:radix parameter
import { Injectable } from '@angular/core';
import { PaymentCard, FournisseurCardsModel } from '../models';
import { QueryParameter, HttpServices } from './http.service';
import { ReferenceService } from './reference.service';
import * as config from '../config/config';
import { Observable } from 'rxjs';
import { FournisseurService } from './fournisseur.service';
import moment from 'moment';
import { map } from 'rxjs/operators';

@Injectable()
export class CreditCardsService {

  constructor(
    private httpServices: HttpServices,
    private referenceService: ReferenceService,
    private fournisseurService: FournisseurService
  ) { }

  fetchAllCreditCards() {
    const cardsList$Tab = [];
    this.fournisseurService.getSuppliersInfosList().forEach(
      supplier => cardsList$Tab.push(this.fetchMapSupplierCreditCards(supplier.FournisseurId))
    );
    return cardsList$Tab;
  }

  fetchMapSupplierCreditCards(supplierId: number): Observable<FournisseurCardsModel> {
    const params: Array<QueryParameter> = [
      { 'Key': 'idSupplier', 'Value': String(supplierId) }
    ];

    return this.httpServices.get<PaymentCard[]>(this.referenceService.staticReferences.Action[config.ApiKeys.GET_CARD_LIST],
      () => { }, params)
      .pipe(map((response: PaymentCard[]) => {
        const defaultCard = response.find(card => card.CardByDefault);
        const defaultCardId = defaultCard ? defaultCard.PaymentMethodCardId : null;
        return { fournisseurId: supplierId, cardsList: response, defaultCardId: defaultCardId };
      }));
  }

  putDefaultCard(cardId: number): Observable<any> {
    const params = [{ 'Key': 'idCard', 'Value': String(cardId) }];
    return this.httpServices.put<any, PaymentCard>(config.ApiKeys.PUT_CARD_DEFAULT, '', () => { }, params);
  }

  removeCard(cardId: number): Observable<boolean> {
    const params = [{ 'Key': 'idCard', 'Value': String(cardId) }];
    return this.httpServices.delete<boolean>(config.ApiKeys.DELETE_CARD, () => { }, params);
  }

  isExpiredCard(card: PaymentCard): boolean {
    if (moment().utc().year() > parseInt('20' + card.CardExpiryDate.substring(2))) {
      return true;
    } else if (moment().utc().year() === parseInt('20' + card.CardExpiryDate.substring(2))
      && moment().utc().month() > parseInt(card.CardExpiryDate.substring(0, 2))) {
      return true;
    }
    return false;
  }
}
